import ReactDOM from 'react-dom';
import { useState } from 'react';
import { AppContextProvider } from '../../Services/AppContext';
import { loadDOMComponent } from '../../helpers';
import MyCalendar from './MyCalendar';

loadDOMComponent({
	selector: 'react-my-calendar',
	callback: ({ container }) => {
		ReactDOM.render(
			<AppContextProvider>
				<MyCalendar />
			</AppContextProvider>,
			container,
		);
	},
});
